import {select} from 'd3';
import debounce from './debounce';
import {formatDefaultLocale} from 'd3-format';

const d3 = {
	select,
	formatDefaultLocale
}

var NL = {
	"decimal": ",",
	"thousands": ".",
	"grouping": [3],
	"currency": ["€\u00a0", ""],
  "dateTime": "%a %e %B %Y %T",
  "date": "%d-%m-%Y",
  "time": "%H:%M:%S",
  "periods": ["AM", "PM"],
  "days": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
  "shortDays": ["zo", "ma", "di", "wo", "do", "vr", "za"],
  "months": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
  "shortMonths": ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"]
};

// import './scss/index.scss';

d3.formatDefaultLocale(NL);

class BaseChart {
	constructor() {
		//default values
		this.container('body');
		this.margin({top: 10, left: 60, bottom: 50, right: 20});
		this.width(500);
		this.height(600);
		this.x(d => d[0])
		this.y(d => d[1])
		this.maxHeight(false);
		this.maxWidth(false);		
		this.responsiveWidth(false);
		this.responsiveHeight(false);
		this.responsive(true);
	}	

	drawSvg(className) {
		this.svg = this.graphicContainer.append('svg')
			.attr('class', `${className} knd-chart` )
		
		this.g = this.svg.append('g')
			.attr('transform',  `translate(${this.margin().left}, ${this.margin().top})`);
	
		this.gLegend = this.svg.append('g').attr('class', 'knd-legend');

		this.updateSvgSize();
	}

	updateSvgSize() {
		this.svg
			.attr('width', this.width() + this.margin().left + this.margin().right)
			.attr('height', this.height() + this.margin().top + this.margin().bottom)			
	}

	container(sel) {
		this.graphicContainer = d3.select(sel);
		return this;
	}

	data(arr) {
		if (!arr) return this._data;
		this._data = arr;
		return this;
	}

	margin(obj) {
		if(!obj) return this._margin;
		this._margin = obj;
		return this;
	}

	x(cb) {
		if (!arguments.length) return this._x;
		this._x = cb;
		return this;
	}

	y(cb) {
		if (!arguments.length) return this._y;
		this._y = cb;
		return this;
	}	

	className(str) {
		if (!arguments.length) return this._className;
		this._className = str;
		return this;
	}	

	key(cb) {
		if (!arguments.length) return this._key;
		this._key = cb;
		return this;
	}	

	// LOTS of HEIGHT & WIDTH

	getParentWidth() {
		const parentNode = this.graphicContainer.node();
		if(!parentNode) return;
		const bbox = parentNode.getBoundingClientRect();
		return bbox.width;
	}

	getParentHeight() {
		const parentNode = this.graphicContainer.node();
		if(!parentNode) return;
		const bbox = parentNode.getBoundingClientRect();
		let height = bbox.height;

		if(this.maxHeight() && this.maxHeight() < height) height = this.maxHeight();

		return height;
	}

	responsiveWidth(bool) {
		if (arguments.length === 0) return this._responsiveWidth;
		this._responsiveWidth = bool;
		return this;
	}

	responsiveHeight(bool) {
		if (arguments.length === 0) return this._responsiveHeight;
		this._responsiveHeight = bool;
		return this;
	}	

	checkWidth() {
		if(this.responsiveWidth()) {
			this.width(this.getParentWidth())
		}

		if(this.maxWidth()) {
			const w = this.maxWidth() && this.maxWidth() < this._originalWidth? this.maxWidth() : this._originalWidth;
			this.width(w);
		}
	}

	checkHeight() {
		if(this.responsiveHeight()) {
			this.height(this.getParentHeight())
		}

		if(this.maxHeight()) {
			const h = this.maxHeight() && this.maxHeight() < this._originalHeight ? this.maxHeight() : this._originalHeight;
			this.height(h);
		}		
	}	

	width(value) {
		if(!value) return this._width;

		if(typeof value === 'number') {
			this._originalWidth = value;
			this._width = value - this.margin().left - this.margin().right;
		}
		else if(typeof value === 'boolean') {
			this.responsiveWidth(value);
			this.checkWidth();
		}

		return this;
	}

	height(value) {
		if(!value) return this._height;

		if(typeof value === 'number') {
			this._originalHeight = value;
			this._height = value - this.margin().top - this.margin().bottom;
		} 
		else if(typeof value === 'boolean') {
			this.responsiveHeight(value);
			this.checkHeight();
		}
		return this;
	}

	maxHeight(value) {
		if (!arguments.length) return this._maxHeight;
		this._maxHeight = value;

		if(value) this.checkHeight();
		return this;
	}

	maxWidth(value) {
		if (!arguments.length) return this._maxWidth;
		this._maxWidth = value;

		if(value) this.checkWidth();
		return this;
	}	

	responsive(bool) {
		if (!arguments.length) return this._responsive;
		this._responsive = bool;

		return this;
	}

	setResponsive() {
		if(this.responsive()) {
			window.addEventListener('resize', debounce(() => this.resize(), 250));			
		}

		return this;
	}

	resize() {
		this.checkWidth();
		this.checkHeight();

		this.updateSvgSize();
		this.resizeChart();
	}
}

export default BaseChart;